import React, { createContext, useContext } from 'react';
import { CapacityPlannerStore } from './CapacityPlannerStore';

// Single module-level store instance — the demo is self-contained and does
// not need to participate in the global RootStore.
const store = new CapacityPlannerStore();

const CapacityPlannerContext = createContext<CapacityPlannerStore>(store);

export const CapacityPlannerProvider = ({ children }: { children: React.ReactNode }) => (
  <CapacityPlannerContext.Provider value={store}>{children}</CapacityPlannerContext.Provider>
);

export const useCapacityStore = (): CapacityPlannerStore =>
  useContext(CapacityPlannerContext);
